import { styled, Tooltip, tooltipClasses, TooltipProps } from "@mui/material";

const HtmlTooltip = styled(({ className, children, ...props }: TooltipProps) =>
  <Tooltip {...props} classes={{ popper: className }} >
    {children}
  </Tooltip>
)(() => ({
  [`& .${tooltipClasses.tooltip}`]: {
    minWidth: 200,
    maxWidth: 450,
    border: "1px solid #dadde9",
    fontSize: "1em"
  },
}));



export default HtmlTooltip;
